
import React from "react";
import { RecipeIdea } from "@/components/admin/tools/recipe-ideas/types";

interface RecipeResultsProps {
  recipes: RecipeIdea[];
  themeClasses: {
    buttonClass: string;
  };
  selectedRecipe: RecipeIdea | null;
  setSelectedRecipe: (recipe: RecipeIdea) => void;
}

const RecipeResults: React.FC<RecipeResultsProps> = ({ 
  recipes, 
  themeClasses,
  selectedRecipe,
  setSelectedRecipe
}) => {
  if (recipes.length === 0) {
    return (
      <div className="p-6 text-center bg-gray-50 rounded-lg">
        <p className="text-lg text-gray-600">No recipes found matching your criteria.</p>
        <p className="text-gray-500 mt-2">Try adjusting your filters or try a different category.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold">Recipe Ideas ({recipes.length}):</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {recipes.map((recipe) => (
          <div 
            key={recipe.id}
            className={`border rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow ${
              selectedRecipe?.id === recipe.id ? 'border-2 border-emerald-500 bg-emerald-50' : 'border-gray-200'
            }`}
            onClick={() => setSelectedRecipe(recipe)}
          >
            <div className="flex justify-between items-start">
              <h4 className="text-lg font-medium">{recipe.title}</h4>
              <span className="px-2 py-1 text-xs rounded bg-gray-100 text-gray-700">
                {recipe.difficulty}
              </span>
            </div>
            <p className="text-gray-600 text-sm mt-1">{recipe.description.substring(0, 100)}...</p>
            <div className="mt-2 flex flex-wrap gap-1">
              {recipe.kidFriendly && (
                <span className="px-2 py-1 text-xs rounded bg-blue-100 text-blue-700">
                  Kid Friendly
                </span>
              )}
              <span className="px-2 py-1 text-xs rounded bg-green-100 text-green-700">
                {recipe.totalTime}
              </span>
              <span className="px-2 py-1 text-xs rounded bg-purple-100 text-purple-700">
                {recipe.category}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecipeResults;
